/**
 * Select Widget
 * Display the selected option
 * ---> Use jQuery
 */

;(function select($) {

  $(window).ready(init);

  var CONTAINER = '.js-Select';
  var SELECT = '.js-Select-option';
  var CONTENT = '.js-Select-content';

  function init() {
    var container = $(CONTAINER);

    if (container.length > 0) {
      updateState();
      container.on('change', SELECT, updateState);
    }
  }

  function updateState() {
    var select = $(SELECT);
    var idvalue = select.find('option:selected').attr('id');
    var content = $(CONTENT + '#' + idvalue);
    var contents= $(CONTENT);

    contents.attr('data-state', 'hide');
    content.attr('data-state', 'show');
  }

})(jQuery);
